import React from "react";
import { delay, motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import {
  containerVariants,
  itemVariants,
  photoVariants,
} from "../../variants/variants";

const Section1 = () => {
  const { t } = useTranslation();

  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      exit="exit"
      variants={containerVariants}

      className="my-14  ">
      <motion.h1 variants={itemVariants} className=" text-65  text-customBlack mb-5 ">{t("rnd.centerTitle")}</motion.h1>

      <motion.p variants={itemVariants} className="text-20 font-medium text-customGray5 mb-14 w-[80%]">
        {t("rnd.text")}
      </motion.p>
    </motion.div>
  );
};

export default Section1;
